import * as TimeActions from '../actions/time';
import { reducer } from './reducerUtils';

const initialState = {
  isTimeEnabled: false,
  isAddingTime: false,
  timeRecords: [],
  isErrorLoadingTimeRecords: false,
  isErrorLoadingTimeConfig: false,
  showTimeReminder: false,
  sendOnSave: false,
  forceEmailSave: false,
  timeProcessing: false,
  billingCodeSets: {},
  timekeepersSelected: {},
};

export default reducer({
  [TimeActions.TIME_ENABLED]: (state, action) => ({
    ...state,
    isTimeEnabled: action.status,
  }),
  [TimeActions.ADDING_TIME]: (state, action) => ({
    ...state,
    isAddingTime: action.payload,
  }),
  [TimeActions.SET_TIME_RECORDS]: (state, action) => ({
    ...state,
    timeRecords: action.payload,
  }),
  [TimeActions.ADD_TIME_RECORD]: (state, action) => ({
    ...state,
    timeRecords: [...state.timeRecords, action.payload],
  }),
  [TimeActions.UPDATE_TIME_RECORD]: (state, action) => {
    const newTimeRecords = [...state.timeRecords];
    newTimeRecords[action.index] = action.payload;
    return {
      ...state,
      timeRecords: newTimeRecords,
    };
  },
  [TimeActions.DELETE_TIME_RECORD]: (state, action) => ({
    ...state,
    timeRecords: state.timeRecords.filter((_, i) => i !== action.index),
  }),
  [TimeActions.DELETE_RELATED_TO_TIME_RECORD]: (state, action) => ({
    ...state,
    timeRecords: state.timeRecords.filter((timeRecord) => timeRecord.litify_time__lit_Related_Record_ID__c !== action.relatedToId),
  }),
  [TimeActions.LOAD_TIME_CONFIG]: (state, { config }) => ({
    ...state,
    config,
  }),
  [TimeActions.IS_ERROR_LOADING_TIME_RECORDS]: (state, action) => ({
    ...state,
    isErrorLoadingTimeRecords: action.status,
  }),
  [TimeActions.IS_ERROR_LOADING_TIME_CONFIG]: (state, action) => ({
    ...state,
    isErrorLoadingTimeConfig: action.status,
  }),
  [TimeActions.SHOW_TIME_REMINDER]: (state, action) => ({
    ...state,
    showTimeReminder: action.status,
  }),
  [TimeActions.SEND_ON_SAVE]: (state, action) => ({
    ...state,
    sendOnSave: action.status,
  }),
  [TimeActions.FORCE_EMAIL_SAVE]: (state, action) => ({
    ...state,
    forceEmailSave: action.status,
  }),
  [TimeActions.SET_SELECTED_TIME_RECORD]: (state, action) => ({
    ...state,
    selectedTimeRecord: action.record,
  }),
  [TimeActions.SET_TIME_PROCESSING]: (state, action) => ({
    ...state,
    timeProcessing: action.status,
  }),
  [TimeActions.SET_BILLING_CODE_SETS]: (state, action) => ({
    ...state,
    billingCodeSets: action.billingCodeSets,
  }),
  [TimeActions.CACHE_TIMEKEEPERS_SELECTED]: (state, action) => ({
    ...state,
    timekeepersSelected: {
      ...state.timekeepersSelected,
      [action.payload.OwnerId]: action.payload.displayName,
    },
  }),
}, initialState);
